module.exports = __webpack_public_path__ + "media/theme/arrow-3-b0d6e3f5.png";